// A reply's follow-up block, split off so it can be drawn LAST.
//
// ★ NOTHING AFTER THE FOLLOW-UPS. The engine writes the follow-up questions as the TAIL of the caption — a
//   `## Follow-up questions` heading and the lines under it — while the preview table arrives beside the
//   caption as its own surface (`ai:done.exports`). Drawn caption-first, the table landed under the
//   follow-ups. So a turn with a table draws the caption's BODY, then the table, then this block.
//
// ★ THE HEADING IS THE CONTRACT'S OWN FALLBACK, AND THE SEARCH IS THE ENGINE'S. The engine also ships the
//   block as data (`ai:done.followups`); its contract (docs/RS2_RESPONSE_STRUCTURE_2026-09-04.md §4) says a
//   UI reads that when present and finds the heading when absent. The reducer (packages/client) does not
//   keep `followups` on a message, and the caption carries the block either way, so the caption is what is
//   split. Both patterns are the engine's own — `buildFollowupMarker` / `_insertBeforeFollowups` in
//   llm-agent/loop.js: the heading after a newline, or a caption that opens with it — and the block runs
//   from the heading to the end, as it does there.
//
// ★ NOTHING IS DROPPED. `body` and `followups` are the caption cut in two at the heading, each trimmed only of
//   the blank lines at the cut; a caption with no heading comes back whole as `body`.
//
// The product webapp carries its own copy of this rule (its AI container is a separately written port).

const FOLLOWUPS_AT = /\n#{1,6}\s*Follow-up questions\b/i;
const FOLLOWUPS_OPENING = /^\s*#{1,6}\s*Follow-up questions\b/i;

export function splitFollowups(caption) {
  const text = typeof caption === "string" ? caption : "";
  if (FOLLOWUPS_OPENING.test(text)) return { body: "", followups: text.trim() };
  const at = text.search(FOLLOWUPS_AT);
  if (at === -1) return { body: text, followups: "" };
  return { body: text.slice(0, at).replace(/\s+$/, ""), followups: text.slice(at).trim() };
}
